import React from 'react';

function NotFound() {
  return (
    <section style={{ textAlign: 'center', padding: '3rem' }}>
      <h2>404 - Page Not Found</h2>
      <p>The page you're looking for doesn't exist.</p>
    </section>
  );
}

export default NotFound;